import { render } from "./WheelDocsPage.vue?vue&type=template&id=80e0f9fc&scoped=true"
import script from "./WheelDocsPage.vue?vue&type=script&lang=js"
export * from "./WheelDocsPage.vue?vue&type=script&lang=js"

import "./WheelDocsPage.vue?vue&type=style&index=0&id=80e0f9fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80e0f9fc"]])

export default __exports__